
/**
 * @typedef {Object} Model
 * @description 模型风格及其属性列表选择
 * @property {Object}
 */
const Model = {
    state: {
      drawModelList: [],
      selectDrawModelData: null,
      selectDrawStyleData: null,

      editModelList: [],
      selectEditModelData: null,
      selectEditStyleData: null,
    },
    reducers: {
      updateState(state, payload) {
        return {
          ...state,
          ...payload
        };
      },
    },
    effects: () => ({

      setDrawModelList(param) {
        this.updateState({ drawModelList: param });
      },
      setEditModelList(param) {
        this.updateState({ editModelList: param });
      },
      setSelectDrawModelData(param) {
        this.updateState({ selectDrawModelData: param });
      },
      setSelectDrawStyleData(param) {
        this.updateState({ selectDrawStyleData: param });
      },
      setSelectEditModelData(param) {
        this.updateState({ selectEditModelData: param });
      },
      setSelectEditStyleData(param) {
        this.updateState({ selectEditStyleData: param });
      },

    })
  };
  
  export default Model;
  